<template>
  <v-dialog :model-value="modelValue" max-width="480" @update:model-value="closeDialog">
    <v-card>
      <v-card-title class="text-h6 d-flex align-center">
        <v-icon class="mr-2">mdi-cog</v-icon>
        Comment settings
      </v-card-title>
      <v-card-text>
        <v-switch
          :model-value="localHideName"
          color="primary"
          inset
          label="Hide my name on comments"
          @update:model-value="updateHideName"
        />
        <div class="text-body-2 text-grey-darken-1">
          If you turn this on, your name will be hidden on comments and replies you post from now on.
        </div>
        <div class="text-body-2 text-grey-darken-1 mt-2">
          Admins will still see your name, and hidden comments will be labelled accordingly.
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn variant="text" :disabled="loading" @click="closeDialog(false)">
          Cancel
        </v-btn>
        <v-btn color="primary" :loading="loading" :disabled="loading" @click="saveChanges">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { ref, watch } from "vue";

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  hideName: {
    type: Boolean,
    default: false,
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["update:modelValue", "save"]);

const localHideName = ref(props.hideName);

watch(
  () => [props.modelValue, props.hideName],
  ([isOpen, hideName]) => {
    if (isOpen) {
      localHideName.value = hideName;
    }
  },
  { immediate: true },
);

const updateHideName = (value) => {
  localHideName.value = Boolean(value);
};

const closeDialog = (value = false) => {
  emit("update:modelValue", value);
};

const saveChanges = () => {
  emit("save", localHideName.value);
};
</script>
